<template>
  <q-banner
    inline-actions
    class="rounded-borders q-pa-md relative-position"
    :class="$q.dark.isActive ? 'bg-deep-orange-10' : 'bg-deep-orange-2'"
  >
    <div :class="dismissible ? 'q-pr-xl' : ''">
      <div v-if="title" class="text-h6">
        {{ title }}
      </div>
      <div v-if="description">
        {{ description }}
      </div>
      <div :class="title || description ? 'q-mt-sm' : ''">
        <slot />
      </div>
    </div>
    <q-btn
      v-if="dismissible"
      class="dismiss-button"
      :color="$q.dark.isActive ? 'white' : 'black'"
      icon="close"
      aria-label="Dismiss warning"
      flat
      dense
      round
      @click="$emit('dismiss')"
    />
    <template v-if="$slots.action" #action>
      <slot name="action" />
    </template>
  </q-banner>
</template>

<script lang="ts">
export default {
  name: 'WarningBanner',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['dismiss']
}
</script>

<style scoped>
.dismiss-button {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
